import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=1200275f&scoped=true"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200275f",
  null
  
)

export default component.exports